<!--
<div id="my-categories-intro" class="text-center">
    <h2>Mis cursos</h2>
    <p>Ésta es una lista de todos los cursos que ha creado, divididos en categorías.</p>
    <p>Para ver un curso, abra la categoría que lo contiene, y haga doble clic para ver el contenido del curso.</p>
</div>
-->

<!--
<div id="categories-loading" class="text-center">
    <p>Cargando...</p>
    <img src="assets/img/loading.gif" alt="Cargando...">
</div>
-->

<!--
<div id="no-categories" class="text-center" *ngIf="numCategories === 0">
    <p><b>No hay cursos que mostrar. Cuando cree un curso, se mostrará aquí.</b></p>
</div>
-->

<ul id="categories-nav" class="mt-4 ms-4" *ngIf="roleSystemAdmin">
    <li id="categories-actions-help" class="dropdown">
        <i class="fas fa-question-circle"></i>
        <span>Ayuda</span>
        <ul id="categories-actions-help-dropdown" class="dropdown-content">
            <li [swal]="['No implementado', '', 'warning']">
                <i class="fas fa-arrow-right"></i>
                <span>Ayuda Certificado Estándar</span>
            </li>
            <li [swal]="['No implementado', '', 'warning']">
                <i class="fas fa-arrow-right"></i>
                <span>Ayuda Certificado Idiomas</span>
            </li>
            <li [swal]="['No implementado', '', 'warning']">
                <i class="fas fa-arrow-right"></i>
                <span>Uso del Editor en Brainscorm</span>
            </li>
            <li [swal]="['No implementado', '', 'warning']">
                <i class="fas fa-arrow-right"></i>
                <span>Cambios Menú Administrador</span>
            </li>
            <li [swal]="['No implementado', '', 'warning']">
                <i class="fas fa-arrow-right"></i>
                <span>Capacidades y Criterios</span>
            </li>
            <li [swal]="['No implementado', '', 'warning']">
                <i class="fas fa-arrow-right"></i>
                <span>Actividades Participativas</span>
            </li>
            <li [swal]="['No implementado', '', 'warning']">
                <i class="fas fa-arrow-right"></i>
                <span>Descargar Videos desde Firefox</span>
            </li>
            <li [swal]="['No implementado', '', 'warning']">
                <i class="fas fa-arrow-right"></i>
                <span>Crear Usuarios</span>
            </li>
            <li [swal]="['No implementado', '', 'warning']">
                <i class="fas fa-arrow-right"></i>
                <span>Gestión Certificados Centros</span>
            </li>
            <li [swal]="['No implementado', '', 'warning']">
                <i class="fas fa-arrow-right"></i>
                <span>Gestión Certificados General</span>
            </li>
        </ul>
    </li>

    <li id="categories-actions-admin" class="dropdown">
        <i class="fas fa-cubes"></i>
        <span>Admin Certificados</span>
        <ul id="categories-actions-admin-dropdown" class="dropdown-content">
            <li [swal]="['No implementado', '', 'warning']">
                <i class="fas fa-arrow-right"></i>
                <span>Asignar Centros a BSC</span>
            </li>
            <li [swal]="['No implementado', '', 'warning']">
                <i class="fas fa-arrow-right"></i>
                <span>Asignar Certificados a BSC</span>
            </li>
            <li [swal]="['No implementado', '', 'warning']">
                <i class="fas fa-arrow-right"></i>
                <span>Asignar Módulos Formativos a BSC</span>
            </li>
            <li [swal]="['No implementado', '', 'warning']">
                <i class="fas fa-arrow-right"></i>
                <span>Asignar Unidades Formativas a BSC</span>
            </li>
            <li [swal]="['No implementado', '', 'warning']">
                <i class="fas fa-arrow-right"></i>
                <span>Asignar Acreditaciones Gestión</span>
            </li>
            <li [swal]="['No implementado', '', 'warning']">
                <i class="fas fa-arrow-right"></i>
                <span>Asignar Organizaciones por Centro</span>
            </li>
            <li [swal]="['No implementado', '', 'warning']">
                <i class="fas fa-arrow-right"></i>
                <span>Asignar Cursos por Unidad Formativa</span>
            </li>
        </ul>
    </li>
    <li id="categories-actions-info" class="dropdown">
        <i class="fas fa-award"></i>
        <span>Info Certificados</span>
        <ul id="categories-actions-info-dropdown" class="dropdown-content">
            <li [swal]="['No implementado', '', 'warning']">
                <i class="fas fa-arrow-right"></i>
                <span>Información General</span>
            </li>
            <li [swal]="['No implementado', '', 'warning']">
                <i class="fas fa-arrow-right"></i>
                <span>Módulos Formativos</span>
            </li>
            <li [swal]="['No implementado', '', 'warning']">
                <i class="fas fa-arrow-right"></i>
                <span>Mostrar Estado del Certificado</span>
            </li>
        </ul>
    </li>
    <li id="categories-actions-config" class="dropdown">
        <i class="fas fa-cog"></i>
        <span>Configuración</span>
        <ul id="categories-actions-config-dropdown" class="dropdown-content">
            <li routerLink="/users" routerLinkActive="active">
                <i class="fas fa-arrow-right"></i>
                <i class="fas fa-users"></i>
                <span>Administrar Usuarios</span>
            </li>
            <li (click)="showOrgsAdmin()">
                <i class="fas fa-arrow-right"></i>
                <span>Administrar Organizaciones</span>
            </li>
            <li [swal]="['No implementado', '', 'warning']">
                <i class="fas fa-arrow-right"></i>
                <span>Administrar Cursos</span>
            </li>
            <li [swal]="['No implementado', '', 'warning']">
                <i class="fas fa-arrow-right"></i>
                <span>Administrar Generadores</span>
            </li>
            <li [swal]="['No implementado', '', 'warning']">
                <i class="fas fa-arrow-right"></i>
                <span>Información Cursos</span>
            </li>
            <li [swal]="['No implementado', '', 'warning']">
                <i class="fas fa-arrow-right"></i>
                <span>Exportar Cursos a Formacion y Tecnología</span>
            </li>
            <li [swal]="['No implementado', '', 'warning']">
                <i class="fas fa-arrow-right"></i>
                <span>Datos Multimedia de Cursos</span>
            </li>
            <li [swal]="['No implementado', '', 'warning']">
                <i class="fas fa-arrow-right"></i>
                <span>Corregir Enunciados de Cursos</span>
            </li>
        </ul>
    </li>
    <li id="categories-actions-queries" class="dropdown">
        <i class="fas fa-clipboard"></i>
        <span>Consultas</span>
        <ul id="categories-actions-queries-dropdown" class="dropdown-content">
            <li [swal]="['No implementado', '', 'warning']">
                <i class="fas fa-arrow-right"></i>
                <span>Resumen de Elementos por Organización</span>
            </li>
            <li [swal]="['No implementado', '', 'warning']">
                <i class="fas fa-arrow-right"></i>
                <span>Resumen de Elementos por Nombre del Curso</span>
            </li>
            <li [swal]="['No implementado', '', 'warning']">
                <i class="fas fa-arrow-right"></i>
                <span>Resumen de Unidades de Aprendizaje</span>
            </li>
            <li [swal]="['No implementado', '', 'warning']">
                <i class="fas fa-arrow-right"></i>
                <span>Excel de Todos los Cursos de Brainscorm</span>
            </li>
            <li [swal]="['No implementado', '', 'warning']">
                <i class="fas fa-arrow-right"></i>
                <span>Información de los Cursos por Organización</span>
            </li>
            <li [swal]="['No implementado', '', 'warning']">
                <i class="fas fa-arrow-right"></i>
                <span>Información Espacio Cursos por Organización</span>
            </li>
            <li [swal]="['No implementado', '', 'warning']">
                <i class="fas fa-arrow-right"></i>
                <span>Información Cursos Rotos por Organización</span>
            </li>
        </ul>
    </li>
</ul>

<div id="categories-left" class="float-start">
    <div id="tree-open-close-buttons" class="my-2 ms-4">
        <button class="btn btn-primary me-3" (click)="jstreeOpenAll()">
            <i class="fa fa-folder-open"></i>
            <span>Abrir todo</span>
        </button>
        <button class="btn btn-primary me-3" (click)="jstreeCloseAll()">
            <i class="fa fa-folder"></i>
            <span>Cerrar todo</span>
        </button>
    </div>

    <div id="categories-tree">
        <div id="jstree"></div>
    </div>
</div>

<div id="separator"></div>

<div id="categories-right" class="float-end">

    <div id="course-search" *ngIf="welcome" class="float-start mt-3 me-5">
        <p class="fw-bold">Buscar curso:</p>
        <input type="text" class="form-control" [(ngModel)]="courseSearchTerm" (keydown.enter)="courseSearch()">
        <button class="btn btn-primary mt-3 me-3" (click)="courseSearch()">
            <i class="fa fa-search"></i>
            <span>Buscar</span>
        </button>
        <button class="btn btn-danger mt-3 me-3" (click)="clearSearch()" *ngIf="search">
            <i class="fa fa-trash"></i>
            <span>Limpiar</span>
        </button>
    </div>

    <div id="brainscorm-welcome" *ngIf="welcome" class="float-start mt-3">
        <div id="brainscorm-welcome-1">
            <img src="assets/img/brainscorm/saludo.png" alt="Saludo">
            <p>Has entrado al sistema como <span class="fw-bold">{{ userName }}</span>.</p>
            <p>A la izquierda se muestran los cursos a los que tienes acceso, organizados por categorías. Para acceder al curso deseado haz doble clic sobre su título.</p>
            <p>Para salir en cualquier momento del sistema, pulse el enlace "Cerrar sesión" situado en la parte superior derecha de la pantalla.</p>
        </div>
        <div id="brainscorm-welcome-2">
            <img src="assets/img/brainscorm/warning.png" alt="">
            <p class="fw-bold">AVISOS IMPORTANTES</p>
            <ul class="list">
                <li>Nunca abras varias pestañas o ventanas de BrainScorm en el mismo navegador web.</li>
                <li>Puedes descargar una copia de seguridad de tu curso de BrainScorm para que en caso de pérdida de información contactes con nosotros y nos puedas enviar el archivo de copia. Pulsa <a href="http://www.brainscorm.com/portalcertificados/ayuda_bs/docs/ayuda_backups.pdf">aquí</a> para conocer cómo se hace.</li>
            </ul>
        </div>
    </div>

    <div id="duplicate-nodes-container" *ngIf="duplicate" class="float-start mt-3">
        <duplicate-nodes [type]="duplicateNodeType" [id]="duplicateNodeId" [name]="duplicateNodeName" [parent]="duplicateNodeParent"></duplicate-nodes>
    </div>

    <div id="users-admin" *ngIf="usersAdmin">
        <users></users>
    </div>

    <div id="users-permissions-admin" class="float-start mt-3" *ngIf="userCoursePermissionsAdmin">
        <users-permissions [edit]="false"></users-permissions>
        <!-- <p class="fw-bold">Resultado de la búsqueda:</p> -->
        <ul id="users-permissions-categories">
            <li *ngFor="let category of userCoursePermissions">
                <h4 class="fw-bold">{{ category.name }}</h4>
                <table id="users-permissions-table" class="table">
                    <thead>
                        <tr>
                            <th>Curso</th>
                            <th>Acceso</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let course of category.courses">
                            <td>{{ course.name }}</td>
                            <td>
                                <div *ngIf="course.created">
                                    <span>Creador del curso, acceso permanente</span>
                                </div>
                                <div *ngIf="!course.created">
                                    <span>Acceso concedido</span>
                                </div>

                            </td>
                        </tr>
                    </tbody>
                </table>
            </li>
        </ul>

        <!-- 
        <button class="btn btn-primary" (click)="showUsersAdmin()">
            <i class="fa fa-arrow-left"></i>
            <span>Volver</span>
        </button> 
        -->
    </div>

    <div id="orgs-admin" *ngIf="orgsAdmin" class="float-start mt-3">
        <h2>Administración de organizaciones</h2>
        
        <div id="orgs-admin-table-div">
        
            <div id="orgs-empty" *ngIf="orgs.length === 0">
                <p>No se han encontrado organizaciones.</p>
            </div>
        
            <div id="org-add-btn" class="mt-3 mb-3">
                <button class="btn btn-primary"> <!-- (click)="addUser()"> -->
                    <i class="fa fa-user-plus"></i>
                    <span>Añadir organización</span>
                </button>
            </div>
        
            <table id="orgs-admin-table" class="table" *ngIf="orgs.length > 0">
                <thead>
                    <tr>
                        <th>Editar</th>
                        <!-- <th>ID</th> -->
                        <th>Nombre</th>
                        <!-- <th>Ver usuarios</th> -->
                        <!-- <th>Eliminar</th> -->
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let org of orgs">
                        <td>
                            <a href="#" (click)="toggleOrgEdit(org)" *ngIf="!org.edit">
                                <i class="fa fa-edit"></i>
                            </a>
                            <a href="#" (click)="editOrg(org)" *ngIf="org.edit">
                                <i class="fa fa-save"></i>
                            </a>
                        </td>
                        <!--
                        <td>{{ org.id }}</td>
                        -->
                        <td>
                            <span *ngIf="!org.edit">{{ org.name }}</span>
                            <input *ngIf="org.edit" type="text" [(ngModel)]="org.name">
                        </td>
                        <!-- 
                        <td>
                            <a href="#" (click)="showUsersAdmin(org.id)">
                                <i class="fa fa-eye"></i>
                            </a> 
                        </td>
                        -->
                        <!--
                        <td>
                            <a href="#" class="red" (click)="deleteUser(user.id)">
                                <i class="fa fa-times"></i>
                            </a>
                        </td>
                        -->
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>

<dialog id="course-form-dialog">
    <ng-container>
        <form method="dialog">
            <button class="btn-close float-end"></button>
            <!-- <button class="btn-close float-end" (click)="closeCourseForm()"></button> -->
        </form>
        <course-form [name]="'COMM04'" [hours]="10" [category]="courseFormCategoryID" [dialog]="true"></course-form>
        <form method="dialog">
            <button class="btn btn-danger mx-3">
                <i class="fas fa-times"></i>
                <span>Cerrar</span>
            </button>
        </form>
    </ng-container>
</dialog>

<dialog id="generate-course-dialog">
    <generate-course [category]="{ 'id': courseFormCategoryID, 'name': courseFormCategoryName }" [dialog]="true"></generate-course>
</dialog>